<div class="main-container">
    <!-- Canvas that contains the wave -->
    <canvas class="canvas-class" #canvasRef></canvas>
</div>
